// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"82":"reportedcase","594":"about"}[chunkId] || chunkId) + "." + {"82":"733c9b01","93":"6770b080","594":"612e0b97","647":"8ef57786"}[chunkId] + ".js";
};